/* eslint-disable import/prefer-default-export */
const CONTENT_WIDGET_TYPES = new Set([
  'text',
  'image',
  'video',
  'separator',
  'cta',
  'cta1',
  'cta2',
  'cta3',
  'iframe',
]);

function isContentWidget(appKey) {
  if (!appKey || typeof appKey !== 'string') return false;
  return CONTENT_WIDGET_TYPES.has(appKey.split('-')[0]);
}

function normalizeKeyEntry(entry) {
  if (!entry?.key || typeof entry.key !== 'string') return null;
  return {
    key: entry.key,
    ...(entry.isDeleted ? { isDeleted: true } : {}),
  };
}

/** De-dupe by key; deletion wins over active/tracked entries for the same key. */
function dedupeKeys(keys) {
  const byKey = new Map();
  for (const raw of keys) {
    const entry = normalizeKeyEntry(raw);
    if (!entry) continue;
    const existing = byKey.get(entry.key);
    if (!existing) {
      byKey.set(entry.key, entry);
      continue;
    }
    byKey.set(entry.key, {
      key: entry.key,
      isDeleted: Boolean(existing.isDeleted || entry.isDeleted),
    });
  }
  return Array.from(byKey.values());
}

/**
 * Build element keys payload for POST /layout (applyChanges on backend).
 *
 * @param {Array} originalLayout - savedLayout before edits
 * @param {Array} currentLayout - editedLayout
 * @param {Object} elements - currentCollective.elements map
 * @param {Array} trackedKeys - optional event-accumulated keys from elementsKeysList
 */
export function buildLayoutSaveKeys(
  originalLayout,
  currentLayout,
  elements,
  trackedKeys = [],
) {
  const safeOriginal = Array.isArray(originalLayout) ? originalLayout : [];
  const safeCurrent = Array.isArray(currentLayout) ? currentLayout : [];
  const safeElements = elements && typeof elements === 'object' ? elements : {};
  const currentAppKeys = new Set(safeCurrent.map((item) => item.appKey));

  const activeKeys = safeCurrent
    .filter((item) => isContentWidget(item.appKey))
    .map((item) => ({ key: item.appKey }));

  const deletedKeys = safeOriginal
    .filter((item) => isContentWidget(item.appKey) && !currentAppKeys.has(item.appKey))
    .filter((item) => safeElements[item.appKey]?.key || item.appKey)
    .map((item) => ({ key: item.appKey, isDeleted: true }));

  const normalizedTracked = (Array.isArray(trackedKeys) ? trackedKeys : [])
    .map(normalizeKeyEntry)
    .filter(Boolean);

  return dedupeKeys([...activeKeys, ...deletedKeys, ...normalizedTracked]);
}

export { isContentWidget };
